import { lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from '../layouts/dashboard';
// components
import { Loadable } from './Loadable';
import RouteGuard from '../guards/RouteGuard';
import Login from '../pages/auth/Login';
import Page404 from '../pages/Page404';
import Page403 from '../pages/Page403';
import telefoniaRoutes from './telefoniaRoutes';
import smsRoutes from './smsRoutes';
import smsNgRoutes from './smsNgRoutes';
import apiSmsNgRoutes from './apiSmsNgRoutes';
import ticketsRoutes from './ticketsRoutes';
import maquinasVirtualesRoutes from './maquinasVirtualesRoutes';
import configuracionesRoutes from './configuracionesRoutes';
import perfilRoutes from './perfilRoutes';
import logsRoutes from './logsRoutes';
import SetPassword from 'src/pages/password/SetPassword';
import RouteGuardPassword from 'src/guards/RouteGuardPassword';

// ----------------------------------------------------------------------

// Dashboard
const Dashboard = Loadable(lazy(() => import('../pages/dashboard/Dashboard')));

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <RouteGuard>
          <DashboardLayout />
        </RouteGuard>
      ),
      children: [
        { element: <Navigate to="/dashboard" replace />, index: true },
        {
          path: 'dashboard',
          element: (
            <RouteGuard>
              <Dashboard />
            </RouteGuard>
          ),
        },

        ...[
          ...telefoniaRoutes,
          ...smsRoutes,
          ...smsNgRoutes,
          ...apiSmsNgRoutes,
          ...ticketsRoutes,
          ...maquinasVirtualesRoutes,
          ...configuracionesRoutes,
          ...perfilRoutes,
          ...logsRoutes,
        ].map((route) => ({
          path: route.path,
          element: (
            <RouteGuard shouldRender={route.shouldRender}>
              <route.component />
            </RouteGuard>
          ),
        })),
      ],
    },
    {
      path: '/auth/login',
      element: <Login />,
    },
    {
      path: '/set-password',
      element: (
        <RouteGuardPassword>
          <SetPassword />
        </RouteGuardPassword>
      ),
    },
    {
      path: '/404',
      element: <Page404 />,
    },
    {
      path: '/403',
      element: <Page403 />,
    },

    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
